import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { VistaRecorridoPage } from './vista-recorrido.page';

const routes: Routes = [
  {
    path: '',
    component: VistaRecorridoPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [VistaRecorridoPage]
})
export class VistaRecorridoPageModule {}
